import { toAmount } from './dashboardWidgets';

const toList = (value) => (Array.isArray(value) ? value.filter(Boolean) : []);

const parseTrendValues = (list, labels) => {
  const byMonth = Object.fromEntries(
    list.map((item) => [item.month || item.label || '', toAmount(item.amount)])
  );
  return labels.map((month) => byMonth[month] ?? 0);
};

const lastTrendPercentage = (list) => {
  if (!list.length) return null;
  const last = list[list.length - 1];
  const pct = Number(last?.percentage);
  return Number.isFinite(pct) ? pct : null;
};

export const parsePerformanceOverview = (data) => {
  const source = data?.result ?? data ?? {};

  const lotsList = toList(source.lotsTrend);
  const referralList = toList(source.referralTrend);
  const summarySource = source.performanceSummary ?? {};

  const labels = [
    ...new Set([
      ...lotsList.map((item) => item.month || item.label || ''),
      ...referralList.map((item) => item.month || item.label || ''),
    ]),
  ].filter(Boolean);

  const chart =
    labels.length > 0
      ? {
          labels,
          lots: parseTrendValues(lotsList, labels),
          referrals: parseTrendValues(referralList, labels),
        }
      : null;

  const summary = {
    totalReferrals: toAmount(summarySource.totalReferrals),
    activeClients: toAmount(summarySource.activeClients),
    totalClients: toAmount(summarySource.totalClients),
    totalLots: toAmount(summarySource.totalLots),
    totalVolume: toAmount(summarySource.totalVolume),
    lotsGrowth: lastTrendPercentage(lotsList),
    referralGrowth: lastTrendPercentage(referralList),
  };

  const hasSummary =
    summary.totalReferrals > 0 ||
    summary.activeClients > 0 ||
    summary.totalClients > 0 ||
    summary.totalLots > 0 ||
    summary.totalVolume > 0;

  if (!chart && !hasSummary) return null;

  return { chart, summary };
};
